"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const stellarService_1 = require("./stellarService");
const stellar_sdk_1 = require("stellar-sdk");
exports.fetchFundDetails = (asset) => __awaiter(void 0, void 0, void 0, function* () {
    const { serviceUrl } = stellarService_1.getConfig();
    const response = yield axios_1.default.get(`${serviceUrl}/transactionfunding_service/conditions`);
    return response.data.find(condition => condition.asset === `${asset.code}:${asset.issuer}`);
});
exports.makeFundPayment = (sourceAddress, asset) => __awaiter(void 0, void 0, void 0, function* () {
    const condition = yield exports.fetchFundDetails(asset);
    return stellar_sdk_1.Operation.payment({
        destination: condition.fee_account_id,
        asset: asset,
        amount: condition.fee_fixed,
        source: sourceAddress,
    });
});
//# sourceMappingURL=fundService.js.map